export default function Monetization() {
  const streams = [
    { code: "01", title: "Contenido", desc: "Cobra por publicaciones premium, suscripciones de fans y contenido exclusivo." },
    { code: "02", title: "Ventas",     desc: "Vende productos físicos y digitales en tu perfil sin comisiones abusivas." },
    { code: "03", title: "Propinas",   desc: "Tus seguidores te apoyan directamente, en cualquier divisa, en un toque." },
    { code: "04", title: "Cursos",     desc: "Lanza talleres y formaciones con pagos integrados y certificados." },
    { code: "05", title: "Referidos",  desc: "Gana cuando recomiendas creadores, productos o comunidades." },
    { code: "06", title: "Pro tools",  desc: "Herramientas para empresas y profesionales con métricas reales." },
  ];

  return (
    <section
      id="monetizacion"
      data-testid="monetization"
      className="bg-ink-deep text-cream py-24 md:py-40 relative overflow-hidden"
    >
      <div className="grain absolute inset-0 opacity-30 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-12 gap-6 mb-20">
          <div className="col-span-12 md:col-span-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
              ◊ Monetización real
            </p>
            <h2 className="mt-5 font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter">
              Si lo creas,<br />
              <span className="italic text-coral">cobras.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-10 space-y-5">
            <p className="text-lg text-cream/80 leading-relaxed text-balance">
              Las redes actuales pagan a un 1%. Ovamx invierte la pirámide. Seis flujos de ingreso integrados desde el primer post — sin pedirte que seas influencer.
            </p>
            <div className="flex flex-wrap gap-x-8 gap-y-3 font-mono text-[10px] uppercase tracking-[0.25em] text-cream/55 pt-3 border-t border-cream/10">
              <span>0% ads invasivos</span>
              <span>· comisiones transparentes</span>
              <span>· pagos en {`<`} 24h</span>
            </div>
          </div>
        </div>

        {/* Streams grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-cream/15">
          {streams.map((s, i) => (
            <div
              key={s.code}
              data-testid={`monetization-${s.code}`}
              className={`p-8 md:p-10 border-b border-cream/15 ${
                (i + 1) % 3 !== 0 ? "md:border-r border-cream/15" : ""
              } group hover:bg-cream/[0.04] transition-colors duration-500`}
            >
              <div className="flex items-baseline justify-between mb-8">
                <span className="font-mono text-xs text-coral">{s.code}</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-500">
                  <path d="M7 17L17 7M17 7H8M17 7v9" />
                </svg>
              </div>
              <h3 className="font-serif text-4xl md:text-5xl leading-none mb-4">{s.title}</h3>
              <p className="text-sm text-cream/70 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        {/* Big metric */}
        <div className="mt-24 md:mt-32 grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-7">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream/55">
              proyección 2027
            </p>
            <p className="mt-4 font-serif text-[16vw] md:text-[10vw] leading-[0.85] tracking-tighter">
              <span className="text-cream">$1.2B</span>
              <span className="text-coral italic"> /año</span>
            </p>
          </div>
          <p className="col-span-12 md:col-span-5 text-base text-cream/70 max-w-md md:pb-3">
            transferidos directamente a creadores ordinarios — no a anunciantes, no a accionistas externos. La economía de Ovamx vuelve a quien la genera.
          </p>
        </div>
      </div>
    </section>
  );
}
